module.exports = "https://static.wanderu.com/static/media/us.c95087e1.svg";